{
  "name": "@xiboplayer/xmds",
  "version": "0.7.23",
  "description": "XMDS SOAP client for Xibo CMS communication",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./xmds-client": "./src/xmds-client.js",
    "./rest-client": "./src/rest-client.js",
    "./schedule-parser": "./src/schedule-parser.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*"
  },
  "devDependencies": {
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "xmds",
    "soap",
    "cms"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/xmds"
  },
  "homepage": "https://xiboplayer.org"
}
